"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.TranslatePipoConstants = undefined;

var _keymirror = require("keymirror");

var _keymirror2 = _interopRequireDefault(_keymirror);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TranslatePipoConstants = exports.TranslatePipoConstants = (0, _keymirror2.default)({
    TRANSLATE_PIPO_REQUEST: null,
    TRANSLATE_PIPO_SUCCESS: null,
    TRANSLATE_PIPO_FAIL: null
});


//////////////////
// WEBPACK FOOTER
// ./src/redux/constants/translate_pipo.js
// module id = 1881
// module chunks = 0